import React from 'react';
import { Checkbox } from '@trainline/depot-web';
import { useIntl } from 'react-intl';
import { css } from 'aphrodite/no-important';

import { TicketTypeFilters, BookingStatusFilters, FilterType } from '../../types';

import messages from './messages';
import styles from './styles';

interface CheckboxesProps {
  checkedItems?: string[];
  onSelect?: (selectedItems: FilterType) => void;
  options: TicketTypeFilters[] | BookingStatusFilters[];
}
const FilterCheckboxes = ({ checkedItems, onSelect, options }: CheckboxesProps) => {
  const { formatMessage } = useIntl();
  return (
    <div className={css(styles.filterCheckBox)}>
      {options.map((option) => (
        <Checkbox
          key={option}
          id={option}
          name={option}
          label={formatMessage(messages[option])}
          value={option}
          checked={checkedItems?.includes(option)}
          onChange={() => onSelect && onSelect(option)}
        />
      ))}
    </div>
  );
};
export default FilterCheckboxes;
